/* SOLÉI ürün sayfası davranışları */
(function () {
  const root = document.querySelector('[data-sl-root]');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const $ = (s, el) => (el || root).querySelector(s);
  const $$ = (s, el) => Array.from((el || root).querySelectorAll(s));
  const variants = JSON.parse(($('[data-sl-variants]') || {}).textContent || '[]');
  const idInput = $('[data-sl-id]');
  const hasSizes = !!$('[data-sl-sizes]');
  let size = null;

  /* teslim tarihi */
  const prod = +root.dataset.production || 5, smin = +root.dataset.shipMin || 1, smax = +root.dataset.shipMax || 3;
  const add = (n) => { const d = new Date(); d.setDate(d.getDate() + n); return d; };
  const fmt = (d) => d.toLocaleDateString('tr-TR', { day: 'numeric', month: 'long' });
  const a = add(prod + smin), b = add(prod + smax);
  const range = a.getMonth() === b.getMonth() ? a.getDate() + '–' + fmt(b) : fmt(a) + ' – ' + fmt(b);
  $$('[data-sl-delivery]').forEach((el) => (el.textContent = range));

  /* WhatsApp */
  const wa = root.dataset.wa;
  $$('[data-sl-wa]').forEach((el) => {
    if (!wa) { el.addEventListener('click', (e) => e.preventDefault()); return; }
    const msg = 'Merhaba, ' + root.dataset.title + ' için beden danışmak istiyorum.';
    el.href = wa + (wa.includes('?') ? '&' : '?') + 'text=' + encodeURIComponent(msg);
    el.target = '_blank'; el.rel = 'noopener';
  });

  /* beden seçimi */
  function setSize(val) {
    size = val;
    const v = variants.find((x) => x.opt === val);
    if (v && idInput) idInput.value = v.id;
    $$('[data-sl-size]').forEach((btn) => btn.setAttribute('aria-pressed', btn.dataset.slSize === val ? 'true' : 'false'));
    $('[data-sl-add]').textContent = val ? val + ' beden — Sepete ekle' : 'Sepete ekle';
    $('[data-sl-err]').hidden = true; $('[data-sl-bar-err]').hidden = true; $('[data-sl-bar-guide]').hidden = false;
    if (v) $$('[data-sl-price]').forEach((el) => (el.textContent = v.price));
  }
  $$('[data-sl-size]').forEach((btn) => {
    const v = variants.find((x) => x.opt === btn.dataset.slSize);
    if (v && !v.available) { btn.disabled = true; btn.setAttribute('aria-label', btn.dataset.slSize + ' tükendi'); }
    btn.addEventListener('click', () => setSize(btn.dataset.slSize));
  });

  /* katmanlar */
  function open(name) { const l = $('[data-sl-layer="' + name + '"]'); if (l) { l.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } }
  function close(l) { l.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  $$('[data-sl-open]').forEach((b) => b.addEventListener('click', () => open(b.dataset.slOpen)));
  $$('[data-sl-layer]').forEach((l) => $$('[data-sl-close]', l).forEach((b) => b.addEventListener('click', () => close(l))));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { $$('[data-sl-layer].is-open').forEach(close); closeLb(); } });

  /* birim değişimi */
  $$('[data-sl-unit]').forEach((b) => b.addEventListener('click', () => {
    const inch = b.dataset.slUnit === 'in';
    $$('[data-sl-unit]').forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    $$('[data-sl-rows] td[data-cm]').forEach((td) => {
      const cm = td.dataset.cm; if (!cm) return;
      td.textContent = inch ? cm.split(/[–-]/).map((n) => (parseFloat(n) / 2.54).toFixed(1).replace('.', ',')).join('–') : cm;
    });
    $('[data-sl-unitnote]').textContent = inch ? 'Ölçüler inç cinsindendir.' : 'Ölçüler santimetre cinsindendir.';
  }));

  /* beden önerici */
  const rows = $$('[data-sl-rows] tr').map((tr) => {
    const td = tr.querySelectorAll('td');
    const rng = (i) => { const p = (td[i] && td[i].dataset.cm || '').split(/[–-]/).map(parseFloat); if (p.length === 1 && !isNaN(p[0])) return [p[0], p[0]]; return p.length === 2 && !p.some(isNaN) ? p : null; };
    return { k: td[0].textContent.trim(), r: [rng(1), rng(2), rng(3)] };
  });
  const vals = [null, null, null];
  function recommend() {
    const box = $('[data-sl-rec]'), txt = $('[data-sl-rec-text]'), pick = $('[data-sl-rec-pick]'), note = $('[data-sl-rec-note]');
    const res = [];
    vals.forEach((v, m) => {
      if (!(v > 0)) return;
      const rs = rows.map((r) => r.r[m]);
      let out = null;
      const first = rs.findIndex(Boolean);
      if (first >= 0 && v < rs[first][0]) out = { i: first, low: true };
      for (let i = 0; i < rs.length && !out; i++) {
        if (!rs[i]) continue;
        if (v >= rs[i][0] && v <= rs[i][1]) out = { i };
        else { const nx = rs.findIndex((x, j) => j > i && x); if (nx > 0 && v > rs[i][1] && v < rs[nx][0]) out = { i: nx, gap: true }; }
      }
      res.push(out || { high: true });
    });
    if (!res.length) { box.hidden = true; note.hidden = true; return; }
    box.hidden = false;
    if (res.some((r) => r.high)) { txt.textContent = 'Ölçüleriniz tablomuzun dışında kalıyor.'; pick.hidden = true; note.hidden = false; note.textContent = 'Size özel bir öneri için WhatsApp üzerinden bize yazın.'; return; }
    const k = rows[Math.max(...res.map((r) => r.i))].k;
    const v = variants.find((x) => x.opt === k);
    txt.textContent = 'Önerilen beden: ' + k;
    pick.hidden = !(v && v.available); pick.onclick = () => { setSize(k); close($('[data-sl-layer="guide"]')); };
    let n = '';
    if (v && !v.available) n = 'Bu beden şu an tükendi; bize yazın, size yardımcı olalım.';
    else if (res.some((r) => r.gap)) n = 'Ölçülerinizden biri iki beden arasında kaldığı için bir büyük bedeni öneriyoruz. Emin olmak için bize yazabilirsiniz.';
    else if (res.some((r) => r.low)) n = 'Ölçülerinizden biri en küçük bedenin altında; kalıp size bol gelebilir.';
    else if (res.length < 3) n = 'Daha isabetli bir öneri için üç ölçüyü de girin.';
    note.hidden = !n; note.textContent = n;
  }
  $$('[data-sl-m]').forEach((inp) => inp.addEventListener('input', () => { vals[+inp.dataset.slM] = parseFloat(String(inp.value).replace(',', '.')); recommend(); }));

  /* sepet */
  const money = (c) => (c / 100).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' TL';
  async function renderCart() {
    const cart = await fetch('/cart.js').then((r) => r.json());
    const body = $('[data-sl-cart-body]'), foot = $('[data-sl-cart-foot]');
    $('[data-sl-cart-title]').textContent = cart.item_count ? 'Sepetiniz (' + cart.item_count + ')' : 'Sepetiniz';
    if (!cart.item_count) { body.innerHTML = '<p style="margin:0;font-size:15px">Sepetiniz şu an boş.</p>'; foot.hidden = true; return; }
    const gift = cart.attributes && cart.attributes['Hediye paketi'] === 'Evet';
    body.innerHTML = cart.items.map((it) => '<div class="sl-line">' + (it.image ? '<img src="' + it.image.replace(/(\.\w+)(\?|$)/, '_400x$1$2') + '" alt="">' : '') +
      '<div style="flex:1;display:flex;flex-direction:column;gap:4px"><div style="display:flex;justify-content:space-between;gap:12px;align-items:baseline"><span class="sl-line__name">' + it.product_title + '</span><span style="font-size:14px">' + money(it.final_line_price) + '</span></div>' +
      (it.variant_title ? '<span class="sl-small">Beden: ' + it.variant_title + ' · Adet: ' + it.quantity + '</span>' : '<span class="sl-small">Adet: ' + it.quantity + '</span>') +
      '<button type="button" class="sl-linkbtn" style="align-self:flex-start;font-size:12px;color:#5C5850;padding:8px 0 0" data-sl-remove="' + it.key + '">Kaldır</button></div></div>').join('') +
      '<div style="border-top:1px solid #E2D9CB;padding-top:16px;display:flex;flex-direction:column;gap:10px"><button type="button" class="sl-check" role="checkbox" aria-checked="' + gift + '" data-sl-gift><i></i>' + (root.dataset.gift || 'Hediye paketi') + '</button>' +
      (gift ? '<textarea class="sl-note" rows="3" maxlength="200" placeholder="Notunuz el yazısıyla karta yazılacaktır" aria-label="Hediye notu" data-sl-note>' + (cart.note || '').replace(/</g, '&lt;') + '</textarea>' : '') + '</div>';
    $('[data-sl-subtotal]').textContent = money(cart.total_price); foot.hidden = false;
    $$('[data-sl-remove]', body).forEach((b) => b.addEventListener('click', async () => { await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: b.dataset.slRemove, quantity: 0 }) }); renderCart(); }));
    const g = $('[data-sl-gift]', body);
    g.addEventListener('click', async () => { await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { 'Hediye paketi': gift ? '' : 'Evet' } }) }); renderCart(); });
    const note = $('[data-sl-note]', body);
    if (note) { let t; note.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) }), 500); }); }
  }
  async function addToCart() {
    if (hasSizes && !size) { $('[data-sl-err]').hidden = false; $('[data-sl-bar-err]').hidden = false; $('[data-sl-bar-guide]').hidden = true; return; }
    const btn = $('[data-sl-add]'); btn.disabled = true;
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +idInput.value, quantity: 1 }] }) });
      if (!r.ok) throw new Error((await r.json()).description || 'Sepete eklenemedi');
      await renderCart();
      const lbl = btn.textContent; btn.textContent = 'Eklendi ✓'; const bb = $('[data-sl-bar-add]'); const bl = bb.textContent; bb.textContent = 'Eklendi ✓';
      setTimeout(() => { btn.textContent = lbl; bb.textContent = bl; open('cart'); }, 900);
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } catch (e) { const er = $('[data-sl-err]'); er.textContent = e.message; er.hidden = false; }
    finally { btn.disabled = false; }
  }
  $('[data-sl-form]').addEventListener('submit', (e) => { e.preventDefault(); addToCart(); });
  $('[data-sl-bar-add]').addEventListener('click', addToCart);

  /* favori (tarayıcıda saklanır) */
  const favKey = 'sl-fav-' + location.pathname;
  const fav = $('[data-sl-fav]');
  try { if (localStorage.getItem(favKey)) fav.setAttribute('aria-pressed', 'true'); } catch (e) {}
  const toast = $('[data-sl-favtoast]'); let toastT;
  fav.addEventListener('click', () => { const on = fav.getAttribute('aria-pressed') !== 'true'; fav.setAttribute('aria-pressed', on); if (toast) { clearTimeout(toastT); toast.hidden = !on; if (on) toastT = setTimeout(() => (toast.hidden = true), 2200); } fav.setAttribute('aria-label', on ? 'Favorilerden çıkar' : 'Favorilere ekle'); try { on ? localStorage.setItem(favKey, '1') : localStorage.removeItem(favKey); } catch (e) {} });

  /* galeri ilerleme çizgisi */
  const track = $('[data-sl-track]'), segs = $$('[data-sl-segs] span');
  track && track.addEventListener('scroll', () => { const i = Math.round(track.scrollLeft / track.clientWidth); segs.forEach((s, j) => s.classList.toggle('is-on', j === i)); }, { passive: true });

  /* görüntüleyici */
  const imgs = $$('[data-sl-img]'), lb = $('[data-sl-lb]'), lbImg = $('[data-sl-lb-img]');
  let cur = 0;
  function show(i) { cur = (i + imgs.length) % imgs.length; lbImg.src = imgs[cur].dataset.full; lbImg.alt = imgs[cur].dataset.alt; lbImg.classList.remove('is-zoom'); $('[data-sl-lb-count]').textContent = (cur + 1) + ' / ' + imgs.length; $('[data-sl-lb-hint]').textContent = 'Yakınlaştırmak için görsele dokunun'; }
  function closeLb() { lb.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  imgs.forEach((b, i) => b.addEventListener('click', () => { show(i); lb.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }));
  $('[data-sl-lb-close]').addEventListener('click', closeLb);
  $('[data-sl-lb-prev]').addEventListener('click', () => show(cur - 1));
  $('[data-sl-lb-next]').addEventListener('click', () => show(cur + 1));
  let tx = null;
  lbImg.addEventListener('touchstart', (e) => { tx = e.touches[0] ? e.touches[0].clientX : null; }, { passive: true });
  lbImg.addEventListener('touchend', (e) => { if (tx == null || lbImg.classList.contains('is-zoom') || (e.touches && e.touches.length)) return; const dx = (e.changedTouches[0] ? e.changedTouches[0].clientX : tx) - tx; tx = null; if (dx > 50) show(cur - 1); else if (dx < -50) show(cur + 1); });
  imgs.forEach((b) => b.addEventListener('mousemove', (e) => { if (window.innerWidth < 990) return; const im = b.querySelector('img'); const r = b.getBoundingClientRect(); if (im) im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%'; }));
  lbImg.addEventListener('click', (e) => {
    if (lbImg.classList.contains('is-zoom')) { lbImg.classList.remove('is-zoom'); $('[data-sl-lb-hint]').textContent = 'Yakınlaştırmak için görsele dokunun'; return; }
    const r = lbImg.getBoundingClientRect(); lbImg.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    lbImg.classList.add('is-zoom'); $('[data-sl-lb-hint]').textContent = 'Uzaklaştırmak için tekrar dokunun';
  });

  /* mobil sabit çubuk: ana buton yukarıda kaybolunca görünür */
  const bar = $('[data-sl-bar]'), main = $('[data-main-add]');
  if (bar && main && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => { const passed = !en.isIntersecting && en.boundingClientRect.bottom < 0; bar.classList.toggle('is-on', passed); bar.setAttribute('aria-hidden', passed ? 'false' : 'true'); }).observe(main);
  }
})();
